import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import styled, { css } from 'styled-components';
import { color } from 'styled-system';
import { themeGet, getBackgroundColor } from '@magalu/stereo-ui-styles';
import Item from '../../atoms/Item';
import Box from '../../atoms/Box';
const displayDirections = {
  left: css`
    left: 0;
    transform: ${({
    visible
  }) => visible ? 'translateX(0)' : 'translateX(-100%)'};
  `,
  right: css`
    right: 0;
    transform: ${({
    visible
  }) => visible ? 'translateX(0)' : 'translateX(100%)'};
  `
};
export const Container = styled.aside`
  z-index: ${props => themeGet('zIndices.2')(props)};
  visibility: ${({
  visible
}) => visible ? 'visible' : 'hidden'};
`;
export const Header = styled(Item).attrs(props => ({
  borderBottom: `1px solid ${getBackgroundColor('darker')(props)}`
}))``;
export const Content = styled(Box).attrs(_ref => {
  let {
    fullScreen
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["visible", "fullScreen"]);

  return {
    backgroundColor: getBackgroundColor((props == null ? void 0 : props.bg) || 'lighter')(props),
    zIndex: themeGet('zIndices.3')(props),
    width: fullScreen ? '100%' : '80%',
    overflowX: 'hidden',
    position: 'fixed',
    overflowY: 'auto',
    textAlign: 'left',
    display: 'block',
    height: '100vh',
    // eslint-disable-next-line no-dupe-keys
    height: '100svh',
    top: 0
  };
})`
  ${color}

  ${({
  direction
}) => displayDirections[direction] || displayDirections.right}
  visibility: ${({
  visible
}) => visible ? 'visible' : 'hidden'};
  transition: ${({
  timeTransition
}) => `transform ${timeTransition}s ease-in-out`};

  /* mobile native toolbar */
  padding-bottom: 54px;
`;
export const Overlay = styled(Box).attrs(_ref2 => {
  let {
    visible
  } = _ref2,
      props = _objectWithoutPropertiesLoose(_ref2, ["visible"]);

  return {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: themeGet('zIndices.2')(props),
    opacity: Number(visible),
    position: 'fixed',
    bottom: 0,
    right: 0,
    left: 0,
    top: 0
  };
})`
  visibility: ${({
  visible
}) => visible ? 'visible' : 'hidden'};
  transition: visibility 0s, opacity 0.3s linear;
`;